if(typeof String.prototype != "function"){
	// ES6
	// From https://github.com/mathiasbynens/String.prototype.repeat
	// http://jsperf.com/string-prototype-repeat-polyfill
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
	String.prototype.repeat = function repeat(count){
		if (this == null) {
			throw new TypeError();
		}
		var string = String(this);
		// `ToInteger`
		var n = count ? Number(count) : 0;
		if (n != n) { // better `isNaN`
			n = 0;
		}
		// Account for out-of-bounds indices
		if (n < 0 || n == Infinity) {
			throw new RangeError();
		}
		var result = "";
		while (n) {
			if (n % 2 == 1) {
				result += string;
			}
			if (n > 1) {
				string += string;
			}
			n >>= 1;
		}
		return result;
	}
}